import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "next-themes";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* Light / dark / system theme. `class` strategy matches tailwind darkMode: ["class"]. */}
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem storageKey="carbonroute-theme">
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
